import type { AdminUserResponseDto } from '@lunary/api-client'
import { LOGIN_METHOD_LABELS } from './labels'

export const NO_NAME = 'Без имени'

export function userIdentifiers(user: AdminUserResponseDto): string[] {
  const emails = [user.email, ...user.oauth_emails].filter((e): e is string => Boolean(e))
  const ids = [...(user.telegram_username ? [`@${user.telegram_username}`] : []), ...emails]
  if (user.telegram_linked && !user.telegram_username) ids.push('Telegram без ника')
  if (emails.length === 0) ids.push(...user.oauth_providers.map((p) => `Вход через ${LOGIN_METHOD_LABELS[p] ?? p}`))
  return [...new Set(ids)]
}

export function userTitle(user: AdminUserResponseDto): { title: string; details: string[] } {
  const ids = userIdentifiers(user)
  if (user.display_name) return { title: user.display_name, details: ids }
  const [first, ...rest] = ids
  return first ? { title: first, details: rest } : { title: NO_NAME, details: [] }
}

export function userLoginMethods(user: AdminUserResponseDto): string[] {
  return [...(user.telegram_linked ? ['telegram'] : []), ...user.oauth_providers]
}
